export const buildingViewCheck = { path: '/api/v1/buildings' };

export const buildingCreateCheck = {
  path: '/api/v1/buildings',
  method: 'POST',
};

export const buildingEditCheck = {
  path: '/api/v1/buildings',
  method: 'PUT',
};

export function searchBuildings(search, contentType) {
  return {
    accept: contentType,
    path: `buildings${search}`,
  };
}

export function getBuilding(buildingId, query = '') {
  return {
    path: `buildings/${buildingId}${query}`,
  };
}

export function getBuildingsByNas(nasId) {
  return {
    path: `buildings?nas_id=${nasId}`,
  };
}

export function createBuilding(body) {
  return {
    path: 'buildings',
    method: 'POST',
    body: JSON.stringify(body),
  };
}

export function updateBuilding(buildingId, body) {
  return {
    path: `buildings/${buildingId}`,
    method: 'PUT',
    body: JSON.stringify(body),
  };
}

export function archiveBuilding(buildingId, archived, updatedBy) {
  return {
    path: `buildings/${buildingId}/archive`,
    method: 'PUT',
    body: JSON.stringify({ archived, updated_by: updatedBy }),
  };
}

export function createBuildingDot1x(buildingId, nasProfileId, smartzoneId) {
  return {
    path: `buildings/${buildingId}/dot1x`,
    method: 'POST',
    body: JSON.stringify({
      building_id: buildingId,
      nas_profile_id: nasProfileId,
      smartzone_id: smartzoneId,
    }),
  };
}

export function deleteBuildingDot1x(buildingId) {
  return {
    path: `buildings/${buildingId}/dot1x`,
    method: 'DELETE',
  };
}

export function getBuildingDot1x(buildingId) {
  return {
    path: `buildings/${buildingId}/dot1x`,
  };
}

export function updateBuildingDot1x(buildingId, body) {
  return {
    path: `buildings/${buildingId}/dot1x`,
    method: 'PUT',
    body: JSON.stringify(body),
  };
}

export function setBuildingSmartzone(buildingId, smartzoneId) {
  return {
    path: `buildings/${buildingId}/dot1x`,
    method: 'PUT',
    body: JSON.stringify({
      smartzoneId,
    }),
  };
}

export function removeBuildingSmartzone(buildingId) {
  return {
    path: `buildings/${buildingId}/dot1x/smartzone`,
    method: 'DELETE',
  };
}

export function getBuildingSatellite(buildingId) {
  return getBuilding(buildingId);
}

export function updateBuildingSatellite(buildingId, body) {
  const { tripFee, ...rest } = body;
  return {
    path: `buildings/${buildingId}/satellite`,
    method: 'PUT',
    body: JSON.stringify({
      tripFee: tripFee / 100.00, // Maintain compatibility with format that Signup expects.
      ...rest,
    }),
  };
}

export function getBuildingProducts(buildingId) {
  return { path: `buildings/${buildingId}/products` };
}

// Redistributes a buildings vlans
export function resetUnitVlans(buildingId) {
  return {
    method: 'POST',
    path: `buildings/${buildingId}/reset_unit_vlans`,
  };
}
export const updateBuildingVlans = (buildingID, body) => ({
  path: `buildings/${buildingID}/update_vlans`,
  method: 'POST',
  body: JSON.stringify(body),
});
